{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "Кампании чата",
      "NEW_CAMPAIGN": "Создать кампанию",
      "CARD": {
        "STATUS": {
          "ENABLED": "Включено",
          "DISABLED": "Выключено"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "Отправитель",
          "BOT": "Бот",
          "FROM": "из",
          "URL": "URL:"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "Нет доступных кампаний чата",
        "SUBTITLE": "Свяжитесь с вашими клиентами с помощью проактивных сообщений. Нажмите 'Создать кампанию', чтобы начать."
      },
      "CREATE": {
        "TITLE": "Создать кампанию чата",
        "CANCEL_BUTTON_TEXT": "Отменить",
        "CREATE_BUTTON_TEXT": "Создать",
        "FORM": {
          "TITLE": {
            "LABEL": "Название",
            "PLACEHOLDER": "Пожалуйста, введите название кампании",
            "ERROR": "Необходимо указать название"
          },
          "MESSAGE": {
            "LABEL": "Сообщение",
            "PLACEHOLDER": "Пожалуйста, введите сообщение кампании",
            "ERROR": "Необходимо ввести сообщение"
          },
          "INBOX": {
            "LABEL": "Выбрать \"Входящий\" канал",
            "PLACEHOLDER": "Выбрать \"Входящий\" канал",
            "ERROR": "Необходимо указать отправителя"
          },
          "SENT_BY": {
            "LABEL": "Отправитель",
            "PLACEHOLDER": "Пожалуйста, выберите отправителя",
            "ERROR": "Необходимо указать отправителя"
          },
          "END_POINT": {
            "LABEL": "URL",
            "PLACEHOLDER": "Пожалуйста, введите правильный URL",
            "ERROR": "Пожалуйста, введите правильный URL",
            "URL_IS_REGEXP": "Значение — регулярное выражение"
          },
          "TIME_ON_PAGE": {
            "LABEL": "Время на страницах (в секундах)",
            "PLACEHOLDER": "Пожалуйста, введите время",
            "ERROR": "Укажите время на странице"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "Другие настройки",
            "ENABLED": "Запустить кампанию",
            "TRIGGER_ONLY_BUSINESS_HOURS": "Включать только в рабочие часы"
          },
          "BUTTONS": {
            "CREATE": "Создать",
            "CANCEL": "Отменить"
          },
          "API": {
            "SUCCESS_MESSAGE": "Кампания чата успешно создана",
            "ERROR_MESSAGE": "Произошла ошибка. Пожалуйста, попробуйте еще раз."
          }
        }
      },
      "EDIT": {
        "TITLE": "Редактировать кампанию чата",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "Кампания чата успешно обновлена",
            "ERROR_MESSAGE": "Произошла ошибка. Пожалуйста, попробуйте еще раз."
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "SMS-кампании",
      "NEW_CAMPAIGN": "Создать кампанию",
      "EMPTY_STATE": {
        "TITLE": "Нет доступных SMS кампаний",
        "SUBTITLE": "Запустите SMS-кампанию, чтобы напрямую связаться с вашими клиентами. Отправляйте предложения или делайте объявления. Нажмите 'Создать кампанию', чтобы начать."
      },
      "CARD": {
        "STATUS": {
          "COMPLETED": "Выполнено",
          "SCHEDULED": "Запланировано"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Отправлено от",
          "ON": "на"
        }
      },
      "CREATE": {
        "TITLE": "Создать SMS-кампанию",
        "CANCEL_BUTTON_TEXT": "Отменить",
        "CREATE_BUTTON_TEXT": "Создать",
        "FORM": {
          "TITLE": {
            "LABEL": "Название",
            "PLACEHOLDER": "Пожалуйста, введите название кампании",
            "ERROR": "Необходимо указать название"
          },
          "MESSAGE": {
            "LABEL": "Сообщение",
            "PLACEHOLDER": "Пожалуйста, введите сообщение кампании",
            "ERROR": "Необходимо ввести сообщение"
          },
          "INBOX": {
            "LABEL": "Выбрать \"Входящий\" канал",
            "PLACEHOLDER": "Выбрать \"Входящий\" канал",
            "ERROR": "Необходимо указать отправителя"
          },
          "AUDIENCE": {
            "LABEL": "Аудитория",
            "PLACEHOLDER": "Выберите метки клиентов",
            "ERROR": "Необходимо указать Аудиторию"
          },
          "SCHEDULED_AT": {
            "LABEL": "Запланированное время",
            "PLACEHOLDER": "Пожалуйста, выберите время",
            "ERROR": "Требуется запланированное время"
          },
          "BUTTONS": {
            "CREATE": "Создать",
            "CANCEL": "Отменить"
          },
          "API": {
            "SUCCESS_MESSAGE": "SMS-кампания успешно создана",
            "ERROR_MESSAGE": "Произошла ошибка. Пожалуйста, попробуйте еще раз."
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "Вы точно хотите удалить?",
      "DESCRIPTION": "Действие удаления окончательно и не может быть отменено.",
      "CONFIRM": "Удалить",
      "API": {
        "SUCCESS_MESSAGE": "Кампания успешно удалена",
        "ERROR_MESSAGE": "Произошла ошибка. Пожалуйста, попробуйте еще раз."
      }
    }
  }
}
